import { Component, Injector, OnInit } from '@angular/core';
import { BaseComponent } from '../../common/BaseComponent';

@Component({
  selector: 'app-admin-auth-fail',
  templateUrl: './admin-auth-fail.component.html',
  styles: [
  ]
})
export class AdminAuthFailComponent extends BaseComponent implements OnInit {

  errorCode: string;

  constructor(
    injector: Injector) {
    super(injector);
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe( params => {
      this.errorCode = params['error_code'];

      
    });
  }

  onSubmit() {
    this.router.navigate(['secure/profile']);
  }

}
